import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'ts0017',
    ecrans: ['00-2'],
    params:['gidcleint']
});
